import { LoadingUI, LoadingVAProps } from './Loading.Presenter';

export function LoadingContainer({ isLogo, sx }: LoadingVAProps) {
  return <LoadingUI isLogo={isLogo} sx={sx} />;
}
